import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ReporteGpsParams {
  type: number;
  format?: string;
  speed_limit?: number;
  devices: number[];
  geofences?: number[];
  date_from: string;
  date_to: string;
  show_addresses?: number;
  zones_instead?: number;
  lang?: string;
}

export interface DeviceSensor {
  id: number;
  type: string;
  name: string;
  show_in_popup: number;
  value: string;
  val: any;
  scale_value: number | null;
  tag_name: string | null;
}

export interface DeviceIcon {
  id: number;
  user_id: number | null;
  type: string;
  order: number | null;
  width: number;
  height: number;
  path: string;
  by_status: number;
}

export interface DriverData {
  id: number | null;
  user_id: number | null;
  device_id: number | null;
  name: string | null;
  rfid: string | null;
  phone: string | null;
  email: string | null;
  description: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface TailPosition {
  lat: string;
  lng: string;
}

export interface DeviceUser {
  id: number;
  email: string;
}

export interface DeviceData {
  id: string;
  traccar_device_id: string;
  icon_id: string;
  active: string;
  deleted: string;
  name: string;
  imei: string;
  fuel_measurement_id: string;
  fuel_quantity: string;
  fuel_price: string;
  fuel_per_km: string;
  sim_number: string;
  device_model: string;
  plate_number: string;
  vin: string;
  registration_number: string;
  object_owner: string;
  expiration_date: string;
  tail_color: string;
  tail_length: string;
  engine_hours: string;
  detect_engine: string;
  min_moving_speed: string;
  min_fuel_fillings: string;
  min_fuel_thefts: string;
  snap_to_road: string;
  created_at: string;
  updated_at: string;
  pivot?: {
    user_id: string;
    device_id: string;
    group_id: string | null;
    current_driver_id: string;
    active: string;
    timezone_id: string | null;
  };
  group_id: string | null;
  current_driver_id: string;
  [key: string]: any; // Para propiedades adicionales
}

export interface Device {
  id: number;
  alarm: string;
  name: string;
  online: string;
  time: string;
  timestamp: number;
  acktimestamp: number;
  lat: number;
  lng: number;
  course: string;
  speed: number;
  altitude: number;
  power: string;
  address: string;
  protocol: string;
  driver: string;
  sensors: string; // JSON string
  services: string; // JSON string
  tail: string; // JSON string
  distance_unit_hour: string;
  device_data: DeviceData;
  // Optional fields that may not always be present
  icon_type?: string;
  icon_color?: string;
  icon_colors?: {
    moving: string;
    stopped: string;
    offline: string;
    engine: string;
    blocked: string;
  };
  icon?: DeviceIcon;
  driver_data?: DriverData;
  unit_of_distance?: string;
  unit_of_altitude?: string;
  unit_of_capacity?: string;
  stop_duration?: string;
  stop_duration_sec?: number;
  moved_timestamp?: number;
  engine_status?: string | null;
  detect_engine?: string;
  engine_hours?: string;
  total_distance?: number;
  inaccuracy?: any;
  sim_expiration_date?: string;
}

export interface DevicesData {
  items: Device[];
  events: any[];
  time: number;
  version: string;
}

export interface DevicesResponse {
  success: boolean;
  message: string;
  data: DevicesData;
}

@Injectable({
  providedIn: 'root'
})
export class GpsService {
 

  constructor(private http: HttpClient) { }

  private apiUrl =  `${environment.apiUrl}/api/reportes`; 
  generarReporte(data: ReporteGpsParams): Observable<any> {
    // Enviar los datos directamente al backend como JSON
    return this.http.post(this.apiUrl, data, { withCredentials: true });
  }

  getDevices(): Observable<DevicesResponse> {
    const devicesUrl = `${environment.apiUrl}/api/devices`;
    return this.http.get<DevicesResponse>(devicesUrl, { withCredentials: true });
  }

 
   
}